import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api-client';

/**
 * The single QueryClient for the app (CONVENTIONS.md §4.4). Defaults are
 * locked: `staleTime: 30_000, retry: 1, refetchOnWindowFocus: false`.
 *
 * `refetchOnWindowFocus: false` is not a taste call — a published fortnight is
 * an immutable snapshot (non-negotiable rule #1). Refetching because someone
 * alt-tabbed during the meeting would be, at best, noise on a projector.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          // Never retry an auth failure or a client mistake — only the one
          // permitted retry, and only for things that might succeed again.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 1;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export const queryClient = createQueryClient();
